export const GRANT_DAYS_MIN = 1;
export const GRANT_DAYS_MAX = 396;
export const GRANT_DAYS_DEFAULT = 30;

export const parseGrantDays = (value: string | null): number | null => {
  if (!value || !/^\d+$/.test(value)) return null;
  const days = Number(value);
  return days >= GRANT_DAYS_MIN && days <= GRANT_DAYS_MAX ? days : null;
};

export const grantAccessLink = (entityId: string, days?: number) =>
  `/control-panel/monitoring?entityId=${encodeURIComponent(entityId)}&grant=1${
    days ? `&days=${days}` : ""
  }`;
